import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { login } from "../redux/handlers/auth/login.handler";
import { VER } from "constants/server/api";
import { LOGO_URL, SERVER_NAME } from "constants/server/config";
import { env } from "env";
export function ChooseRegister() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    return /*#__PURE__*/ _jsx("div", {
        className: "loginpage bg-white",
        children: /*#__PURE__*/ _jsxs(Row, {
            className: "g-0",
            children: [
                /*#__PURE__*/ _jsx(Col, {
                    lg: 7,
                    xl: 8,
                    className: "d-none d-xl-block",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: "/images/banner_login.png",
                        className: "w-100",
                        style: {
                            height: "100vh",
                            objectFit: "cover"
                        }
                    })
                }),
                /*#__PURE__*/ _jsx(Col, {
                    className: "d-flex justify-content-center align-items-center h-100vh",
                    children: /*#__PURE__*/ _jsx(Card, {
                        className: "box-login",
                        children: /*#__PURE__*/ _jsxs(Card.Body, {
                            className: "",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        src: env.REACT_APP_LOGO_URL,
                                        width: 200,
                                        className: "mb-4 mx-auto"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-18 fw-500 mb-3 tc-1",
                                    children: "สมัครสมาชิก"
                                }),
                                /*#__PURE__*/ _jsxs(Button, {
                                    type: "button",
                                    className: "btn-register w-100 mb-4 text-start d-flex align-items-center",
                                    onClick: function() {
                                        return navigate("/register");
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "icon-mail mr-2"
                                        }),
                                        " สมัครสมาชิกผ่าน Email"
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "text-center tc-6 mb-3",
                                    children: [
                                        "คุณมีบัญชีอยู่แล้วใช้ไหม ",
                                        /*#__PURE__*/ _jsx(Link, {
                                            to: "/login",
                                            variant: "link",
                                            className: "alink-st-1 tc-5",
                                            children: "เข้าสู่ระบบ"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center",
                                    children: /*#__PURE__*/ _jsx(Link, {
                                        to: "/login",
                                        variant: "link",
                                        className: "alink-st-1 tc-1",
                                        children: "กลับหน้าหลัก"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
